export default __webpack_public_path__ + "static/media/learn-english-janet-belshaw-English-Teacher.59726c52.webp";